import React, { useMemo, useState, useEffect } from 'react';
import { Line, HorizontalBar, Bar, Doughnut, Pie, Radar, Polar, Bubble, Scatter } from 'react-chartjs-2';
import { compose, withHandlers, withPropsOnChange } from "recompose";
import { range } from "lodash";
import { LocalForm, Control, actions } from "react-redux-form";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  SubmitButton,
} from "components/common";
import Select from "react-select";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import { getMonthEnd, getMonthStart } from "../Xero/Reports/util";
import { Trans, useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { withDefaultReportParams } from "../Xero/Reports/hooks/useDefaultReportParams";
import MainCard from './MainCard';

const trackingCategories = [];


const refreshChart = () => {
    window.location.reload();
  };

export const ProfitAndLoss = ({
  data,
  item: itemProp,
  handleSubmit,
  setState,
  timeframes,
  periods,
  settings,
  organisation,
  dispatch,
}) => {

  const { t } = useTranslation();
  const [item, setItem] = useState(itemProp);

  const getRandomColors = () => {
    const baseColor = [
        Math.floor(100 + Math.random() * 156), 
        Math.floor(100 + Math.random() * 156),
        Math.floor(100 + Math.random() * 156),
      ];
    
      const darkColor = `rgba(${baseColor[0]}, ${baseColor[1]}, ${baseColor[2]}, 0.6)`;
      const lightColor = `rgba(${Math.min(baseColor[0] + 90, 255)}, ${Math.min(baseColor[1] + 90, 255)}, ${Math.min(baseColor[2] + 90, 255)}, 0.6)`;
    
      return [darkColor, lightColor];
    };

  const sectionTitle = "Less Operating Expenses";
  
  const getTotalExpenses = (data, n) => {
    console.log('Data:', data);
    const section = data.Rows.find(row => row.RowType === 'Section' && row.Title === sectionTitle);
    console.log('Section:', section);
    const summaryRow = section?.Rows.find(row => row.RowType === 'SummaryRow');
    console.log('Summary Row:', summaryRow);
  
    return summaryRow ? summaryRow.Cells[n]?.Value : undefined;
  };
  
  const totalExpensesName = getTotalExpenses(data, 0);

  const totalExpensesValues = Array.from({ length: 12 }, (_, index) => {
    return parseInt(getTotalExpenses(data, index + 1)) || 0;
  });
  
  const totalExpensesSum = totalExpensesValues.reduce((acc, value) => acc + value, 0);
  
  const section = data.Rows.find(
    (row) => row.RowType === 'Section' && row.Title === sectionTitle
  );
  
  const numberOfRows = section?.Rows?.length || 0;
  
  const firstRow = section?.Rows?.[0];
  const numberOfValueCells = firstRow?.Cells?.length || 0;
  
  const getSummaryCellValue = (data, n, k) => {
    const summaryRows = section?.Rows?.filter((row) => row.RowType === 'Row');
    const summaryRow = summaryRows ? summaryRows[n] : undefined;
  
    return summaryRow && summaryRow.Cells && summaryRow.Cells[k] ? summaryRow.Cells[k].Value : undefined;
  };
  
  const rowTotalSums = Array.from({ length: numberOfRows }, (_, index) => {
    const rowName = getSummaryCellValue(data, index, 0);
    const totalSum = Array.from({ length: numberOfValueCells }, (_, cellIndex) => {
      const cellValue = getSummaryCellValue(data, index, cellIndex + 1);
      return parseFloat(cellValue) || 0;
    }).reduce((acc, value) => acc + value, 0);
  
    return { rowIndex: index, rowName, totalSum };
  });
  
  const sortedTotalSums = rowTotalSums.sort((a, b) => b.totalSum - a.totalSum);
  const top5TotalSums = sortedTotalSums.slice(0, 5);


const totalPercentage = (value, total) => {
  if (total === 0) return 0; // Handle division by zero

  const percentage = (value / total) * 100;
  return Math.min(100, Math.max(0, parseFloat(percentage.toFixed(2))));
};

const [value1, value2, value3, value4, value5] = Array.from({ length: 5 }, (_, index) =>
  top5TotalSums.length > index
    ? totalPercentage(top5TotalSums[index]?.totalSum, totalExpensesSum) || 0
    : 0
);

function convertRowName(rowName) {
  return rowName?.replace(/[-0-9]/g, digit => String.fromCharCode(1632 + parseInt(digit))) || "Error";
}
  
  const displayRowName1 = convertRowName(top5TotalSums[0]?.rowName);
  const displayRowName2 = convertRowName(top5TotalSums[1]?.rowName);
  const displayRowName3 = convertRowName(top5TotalSums[2]?.rowName);
  const displayRowName4 = convertRowName(top5TotalSums[3]?.rowName);
  const displayRowName5 = convertRowName(top5TotalSums[4]?.rowName);

  const otherExpenses = "Other Expenses"
  
  const [darkColor1, lightColor1] = getRandomColors();
  const [darkColor2, lightColor2] = getRandomColors();
  const [darkColor3, lightColor3] = getRandomColors();



  const adjustedValue = parseFloat(Math.max(0, 100 -value1 - value2 - value3)).toFixed(2);;


  console.log(adjustedValue + "%");

  const filterExpenses = (data) => {
    return data.filter((item) => !(item.expenseName === "Error" && item.value === 0));
  };
  
  
  const expensesDataOne = filterExpenses([
    { id: 1, expenseName: displayRowName1, value: value1, color: darkColor1 },
    { id: 2, expenseName: otherExpenses, value: Math.max(0, 100 - value1), color: lightColor1 },
  ]);
  
  const expensesDataTwo = filterExpenses([
    { id: 1, expenseName: displayRowName2, value: value2, color: darkColor2 },
    { id: 2, expenseName: otherExpenses, value: Math.max(0, 100 - value2), color: lightColor2 },
  ]);
  
  const expensesDataThree = filterExpenses([
    { id: 1, expenseName: displayRowName3, value: value3, color: darkColor3 },
    { id: 2, expenseName: otherExpenses, value: Math.max(0, 100 - value3), color: lightColor3 },
  ]);

  const expensesDataFour = filterExpenses([
    { id: 1, expenseName: displayRowName1, value: value1, color: darkColor1 },
    { id: 2, expenseName: displayRowName2, value: value2, color: darkColor2 },
    { id: 3, expenseName: displayRowName3, value: value3, color: darkColor3 },
    { id: 4, expenseName: otherExpenses, value: adjustedValue, color: lightColor3 },
  ]);
  
const [expensesChartDataOne, setExpensesDataOne] = useState({});

const [expensesChartDataTwo, setExpensesDataTwo] = useState({});

const [expensesChartDataThree, setExpensesDataThree] = useState({});

const [expensesChartDataFour, setExpensesDataFour] = useState({});

const convertTableToChartData = (tableData, labelKey, dataKey, chartType) => {
  const labels = tableData.map((item) => item[labelKey]);
  const data = tableData.map((item) => item[dataKey]);
  const colors = tableData.map((item) => item.color);

  return {
    labels,
    datasets: [
      {
        label: 'Chart Data',
        data,
        backgroundColor: colors,
        borderColor: 'grey',
        borderWidth: 0.5,
      },
    ],
  };
};
  
useEffect(() => {
    const convertAndSetChartData = (expensesData, setStateFunction, chartLabel) => {
      const expensesChart = convertTableToChartData(expensesData, 'expenseName', 'value', 'doughnut');
      const chartData = {
        labels: expensesChart.labels,
        datasets: [
          {
            label: chartLabel,
            data: expensesChart.datasets[0].data,
            backgroundColor: expensesChart.datasets[0].backgroundColor,
            borderColor: 'grey',
            borderWidth: 0.5,
          },
        ],
      };
      setStateFunction(chartData);  
    };
  
    convertAndSetChartData(expensesDataOne, setExpensesDataOne, 'Expenses 1');
    convertAndSetChartData(expensesDataTwo, setExpensesDataTwo, 'Expenses 2');
    convertAndSetChartData(expensesDataThree, setExpensesDataThree, 'Expenses 3');
    convertAndSetChartData(expensesDataFour, setExpensesDataFour, 'Expenses 4');
  }, []);
  



  const compareOptions = useMemo(
    () => [
      {
        label: t("Compare Periods"),
        value: "periods",
      },
      ...trackingCategories.map((i) => ({
        value: i.TrackingCategoryID,
        label: t("Compare {{ Name }}", i),
      })),
    ],
    [t, trackingCategories]
  );

  const { compare } = item;

  const chartTitle = t("Expenses Chart")

  const orgName = data?.ReportTitles[1] || t("Default"
)
  return (
    <Page title={chartTitle} printTitle={false} translate={false}>
      <LocalForm
        className="d-print-none"
        getDispatch={(dispatch) => setState({ dispatch })}
        onSubmit={handleSubmit}
        onChange={setItem}
        initialState={item}
      >
        <Row form>
          <Col lg="auto">
            <FormGroup label="From date">
              <DatePicker model=".fromDate" className="form-control" />
            </FormGroup>
          </Col>
          <Col lg="auto">
            <FormGroup label="To date">
              <DatePicker
                style={{ width: "12rem" }}
                model=".toDate"
                className="form-control"
              />
            </FormGroup>
          </Col>
          {trackingCategories.length ? (
            <Col lg="auto">
              <FormGroup label="Compare" addControlClass={false}>
                <Control.select
                  component={Select}
                  style={{ minWidth: "13rem" }}
                  options={compareOptions}
                  searchable={false}
                  simpleValue
                  clearable={false}
                  model=".compare"
                />
              </FormGroup>
            </Col>
          ) : null}
          {compare === "periods" && (
            <>
              <Col lg="auto">
                <FormGroup label="Periods" addControlClass={false}>
                  <Control.select
                    component={Select}
                    simpleValue
                    style={{ minWidth: "10rem" }}
                    options={periods}
                    clearable={false}
                    searchable={false}
                    model=".periods"
                  />
                </FormGroup>
              </Col>
              <Col lg="auto">
                <FormGroup label="Timeframe" addControlClass={false}>
                  <Control.select
                    component={Select}
                    simpleValue
                    clearable={false}
                    style={{ minWidth: "10rem" }}
                    options={timeframes}
                    searchable={false}
                    model=".timeframe"
                  />
                </FormGroup>
              </Col>
            </>
          )}
          <Col lg="auto">
            <FormGroup label="&nbsp;" className="mr-3">
              <FormGroup label="Cash transactions only" check>
                <Control.checkbox model=".paymentsOnly" />
              </FormGroup>
            </FormGroup>
          </Col>
          <Col lg="auto">
            <FormGroup label="&nbsp;">
              <SubmitButton size="sm" className="d-block">
                Update
              </SubmitButton>
            </FormGroup>
          </Col>
        </Row>
    <div className='my-4 text-center' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '20px', maxWidth: '1200px', overflow: 'auto' }}>
     <MainCard linkTo="/reports/profit_and_loss">
     <div style={{ flexDirection: 'column', alignItems: 'center', gap: '60px', maxWidth: '1000px' }}>

        {/* Expenses Calculations */}
        {expensesChartDataFour.labels && expensesChartDataFour.labels.length > 2 ? (
        <div>
        <h4><Trans>Expenses Calculations for</Trans> {data.ReportTitles[1]}</h4>
        <div style={{ marginBottom: '20px' }}>
            <Doughnut data={expensesChartDataFour} options={{ maintainAspectRatio: true, responsive: true }} />
        </div>
        <p><strong>{expensesDataThree[0].value}%</strong> <Trans>of your</Trans> <strong>{t(totalExpensesName)}</strong> <Trans>comes from</Trans> {expensesDataThree[0].expenseName}</p>
        <p><strong>{expensesDataTwo[0].value}%</strong> <Trans>of your</Trans> <strong>{t(totalExpensesName)}</strong> <Trans>comes from</Trans> {expensesDataTwo[0].expenseName}</p>
        <p><strong>{expensesDataOne[0].value}%</strong> <Trans>of your</Trans> <strong>{t(totalExpensesName)}</strong> <Trans>comes from</Trans> {expensesDataOne[0].expenseName}</p>
        </div>
        ) : (
          <>
            <h4 className='text-left pb-3'><Trans>System couldn't find any 'Expenses.'</Trans></h4>
            <div className='text-muted' style={{ fontStyle: "italic", fontSize: "1.3em"}}>
              <p><Trans>Expenses for the Account of</Trans> {orgName} <Trans>was not found.</Trans></p>
              <p><Trans>Please utilize Expenses accounts for it's charts.</Trans></p>
            </div>
          </>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>

        {expensesChartDataOne.labels && expensesChartDataOne.labels.length > 1 && (
        <div>
            <Doughnut data={expensesChartDataOne} options={{ maintainAspectRatio: true, responsive: true }} />
            <h4 style={{ marginTop: '20px' }}>{expensesDataOne[0].expenseName} <Trans>Chart</Trans></h4>
        </div>
        )}

        {expensesChartDataTwo.labels && expensesChartDataTwo.labels.length > 1 && (
        <div>
            <Doughnut data={expensesChartDataTwo} options={{ maintainAspectRatio: true, responsive: true }} />
            <h4 style={{ marginTop: '20px' }}>{expensesDataTwo[0].expenseName} <Trans>Chart</Trans></h4>
        </div>
        )}

        {expensesChartDataThree.labels && expensesChartDataThree.labels.length > 1 && (
        <div>
            <Doughnut data={expensesChartDataThree} options={{ maintainAspectRatio: true, responsive: true }} />
            <h4 style={{ marginTop: '20px' }}>{expensesDataThree[0].expenseName} <Trans>Chart</Trans></h4>
        </div>
        )}

        </div>
      </div>
    </MainCard>
    </div>
    </LocalForm>
    </Page>
  );
};

const loadReport = (item, xero) =>
  xero.get("reports/ProfitAndLoss", {
    params: {
      extra_params: item,
    },
  }).get("data");

export const enhance = compose(
  withOrganisationContextConsumer,
  withDefaultReportParams(() => ({
    fromDate: getMonthStart(),
    toDate: getMonthEnd(),
    periods: 5,
    compare: "periods",
    timeframe: "MONTH",
  })),
  onMount(({ xero, fetchSettings, fetchOrganisation, item }) => () => {
    return Promise.props({
      data: loadReport(
        {
          ...item,
          tracking_category:
            item.compare !== "periods" ? item.compare : undefined,
        },
        xero
      ),
      settings: fetchSettings(),
      organisation: fetchOrganisation(),
      item,
    });
  }),
  withPropsOnChange(["t"], ({ t }) => ({
    periods: range(1, 11 + 1).map((i) => ({ label: i, value: i })),
    timeframes: [
      ["MONTH", t("Month")],
      ["QUARTER", t("Quarter")],
      ["YEAR", t("Year")],
    ].map(([value, label]) => ({ label, value })),
  })),
  withHandlers({
    handleSubmit:
      ({ setState, xero, dispatch, setReportParams }) =>
      (item) => {
        setReportParams(item);
        return loadReport(
          {
            ...item,
            tracking_category:
              item.compare !== "periods" ? item.compare : undefined,
          },
          xero
        )
          .then((data) => { setState({ data });refreshChart();})
          .finally(() => dispatch(actions.setSubmitted("local", true)));
      },
  })
);

export default enhance(ProfitAndLoss);
